import { Dropdown } from 'react-bootstrap';
import { useContext } from 'react';
import { ConnectorGroupContext } from 'shiplab-components/ConnectorGroupManagementPanel';
import { ConnectorGroup } from 'models/ConnectorGroup';

type ConnectorGroupTableActionDropdownProps = {
  connectorGroup: ConnectorGroup;
};

const ConnectorGroupTableActionDropdownItems: React.FC<ConnectorGroupTableActionDropdownProps> = ({ connectorGroup }) => {
  const context = useContext(ConnectorGroupContext);

  if (!context) {
    return null;
  }

  const { handleEdit, handleDelete } = context;

  return (
    <>
      {/* <Dropdown.Item eventKey="1" onClick={() => handleEdit(connectorGroup)}>Edit</Dropdown.Item> */}
      <Dropdown.Item eventKey="4" className="text-danger" onClick={() => handleDelete(connectorGroup)}>Delete</Dropdown.Item>
    </>
  );
};

export default ConnectorGroupTableActionDropdownItems;

